// extracted by mini-css-extract-plugin
module.exports = {"hidden":"resultSave_hidden___TO5B","textEmphasis":"resultSave_textEmphasis__NvPIu","wrap":"resultSave_wrap__JeErq"};